import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const ReOptApprovalMock = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3">
      <div className="bg-[#1e1e2e] border border-white/[0.06] rounded-lg overflow-hidden">
        {/* Modal header */}
        <div className="flex items-center gap-3 px-5 py-4 border-b border-white/[0.06]">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-lg text-orange-400" />
          <div>
            <h3 className="text-sm font-semibold text-white">Re-Optimization Required</h3>
            <p className="text-xs text-gray-400 mt-0.5">Strategy performance has degraded below thresholds</p>
          </div>
        </div>

        {/* Current performance */}
        <div className="px-5 py-3 border-b border-white/[0.06]">
          <h4 className="text-[10px] text-gray-500 uppercase tracking-wide mb-2">Current Performance</h4>
          <div className="grid grid-cols-4 gap-3 text-sm">
            {[
              { label: 'Trades', value: '47' },
              { label: 'Win Rate', value: '38.2%' },
              { label: 'P&L', value: '-$1,240' },
              { label: 'Drawdown', value: '-14.8%' },
            ].map((m) => (
              <div key={m.label}>
                <div className="text-[9px] text-gray-500 uppercase tracking-wide">{m.label}</div>
                <div className={`font-medium ${m.label === 'P&L' || m.label === 'Drawdown' ? 'text-rose-400' : 'text-white'}`}>{m.value}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Compliance notes */}
        <div className="px-5 py-3 border-b border-white/[0.06]">
          <h4 className="text-[10px] text-gray-500 uppercase tracking-wide mb-2">Compliance Notes (Required)</h4>
          <div className="h-16 bg-gray-800/50 rounded border border-gray-700 p-2 text-xs text-gray-300">
            Sharpe ratio declined below 0.8 threshold for 3 consecutive windows. Drawdown recovery exceeded 45 days. Approving re-optimization with narrowed parameter search space.
          </div>
        </div>

        {/* Actions */}
        <div className="px-5 py-3 flex items-center gap-3">
          <div className="flex-1 flex items-center justify-center py-2 bg-emerald-600 text-white rounded text-sm font-medium">
            Approve
          </div>
          <div className="flex-1 flex items-center justify-center py-2 bg-amber-600 text-white rounded text-sm font-medium">
            Defer
          </div>
          <div className="flex-1 flex items-center justify-center py-2 bg-rose-600 text-white rounded text-sm font-medium">
            Reject
          </div>
        </div>

        {/* Legal */}
        <div className="px-5 py-2 text-[9px] text-gray-600 border-t border-white/[0.06]">
          All decisions are logged for compliance audit purposes.
        </div>
      </div>
    </div>
  </div>
);

export default ReOptApprovalMock;
